document.addEventListener("DOMContentLoaded", function () {
  const sliderElements = document.querySelectorAll(".splide.section-product__item"); 
  
  function initSplide() {
    sliderElements.forEach((sliderElement) => {
      let splideInstance; 
      if (splideInstance) {
        splideInstance.destroy(true);
        splideInstance = null;
      }

      if (window.innerWidth < 768) {
        console.log("Inicializando Splide para:", sliderElement);
        const instance = new Splide(sliderElement, {
          type: "slide",
          rewind: true,
          perPage: 1,
          focus: "center",
          pagination: true,
          arrows: false,
        }).mount();
      }
    });
  }

  initSplide();
  window.addEventListener("resize", initSplide);
});

